import { HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const maxAge = 30000;

class HttpCache {
  createdOn: number;
  value: HttpResponse<any> | Observable<HttpEvent<any>>;

  constructor(value: HttpResponse<any> | Observable<HttpEvent<any>>) {
    this.createdOn = Date.now();
    this.value = value;
  }
}

@Injectable()
export class HttpCacheService {
  private cache: Map<string, HttpCache> = new Map<string, HttpCache>();

  getValue(
    httpRequest: HttpRequest<any>
  ): HttpResponse<any> | Observable<HttpEvent<any>> | undefined {
    const key = this.getCacheKey(httpRequest);
    const cachedValue = this.cache.get(key);

    if (cachedValue == null || this.hasExpired(cachedValue)) {
      return undefined;
    } else {
      return cachedValue.value;
    }
  }

  setValue(httpRequest: HttpRequest<any>, value: HttpResponse<any> | Observable<HttpEvent<any>>) {
    this.cache.set(this.getCacheKey(httpRequest), new HttpCache(value));
  }

  private getCacheKey(httpRequest: HttpRequest<any>) {
    return httpRequest.urlWithParams;
  }

  private hasExpired(cachedValue: HttpCache) {
    return cachedValue.createdOn + maxAge < Date.now();
  }
}
